import { render, staticRenderFns } from "./WaterMetricTable.vue?vue&type=template&id=b959a0f6&scoped=true&"
import script from "./WaterMetricTable.vue?vue&type=script&lang=js&"
export * from "./WaterMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b959a0f6",
  null
  
)

export default component.exports